import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import UCSColors from "@ucs/Utils/UCSColors";
import * as React from "react";
import { connect } from "react-redux";
import styled, { css } from "styled-components";

const OrderNowContainer = styled.div`
    background-color: transparent;
    padding: 10% 25%;
    height: 100%;
    h5 {
        border-top: 2px solid ${UCSColors.gray07};
        padding: 13px 0px;
    }

    ${({ theme }) => {
        const { maxWidths } = theme.breakpoints;
        return breakpointMediaQueries(theme, [
            css`
                padding: 10% 10%;
            `,
            css`
                padding: 10% 10%;
            `,
        ]);
    }}
`;

const ProductDetailsView: React.FC<WidgetProps> = ({ id }: WidgetProps) => {
    return (
        <OrderNowContainer>
            <Zone contentId={id} zoneName="Content"></Zone>
        </OrderNowContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect()(ProductDetailsView),
    definition: {
        displayName: "View",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
